<template>
  <div class="about">
    <img :src="bannerImg" class="bannerImg" />
    <an-child>
      <div slot="c_left" class="left_nav">
      	<h3 class="title-color"><a>{{$store.state.langData.culture.title}}</a></h3>
        <ul>
          <li v-for="(item,index) in cleft" :key="index">
            <router-link :to="'/culture?type='+item.type" exact>{{item.name}}</router-link>
          </li>
        </ul>
      </div>
      <div slot="c_right">
	      <div class="d-flex bread">
	          <h3 class="flex-auto"><a class="text-blue">{{title}}</a></h3>
	          <div class="text-gray_dark d-flex">
	            <span><img src="@/assets/images/p.png" class="pic"></span>
	            {{$store.state.langData.nowAddress}}：           
	            <router-link :to="'/culture?type='+type">{{$store.state.langData.culture.title}}</router-link>>
	            <a>{{title}}</a>
	          </div>
	      </div>
        <!-- <div class="text-center" v-show="content==''">{{$store.state.langData.noData}}</div> -->
          <!-- <div v-html="content"></div> -->
        <div class="news_events">
          <!--<h2><span>{{$store.state.langData.products.brand}}</span>{{title}}</h2>-->
          <div class="culture_list">
            <div v-for="(i,n) in cultureList.filter(i=>!i.hide)" :key="n">
              <router-link class="culture-link"
                :to="'/detail?handler=getCultureDetail&filed=video&id='+i.id"
              v-if="i.type == 1">
                <div class="news_list_item">
                  <div class="ofl">
                    <img :src="i.imageUrl" class="video_style" alt>
                  </div>
                  <div class="sec_box font16">
                    <h5 class="text-center">{{i.title}}</h5>
                    <!-- <p class="intro">{{i.matSpec}}</p> -->
                    <p class="indicationfunction">{{i.subhead | limitWord(70)}}</p>
                    <!-- <p class="factory">{{i.matFactory}}</p> -->
                    <a href="#">{{$store.state.langData.culture.checkDetail}}</a>
                  </div>
                </div>
              </router-link>
                <!-- <router-link class="culture-link"
                :to="'/detail?handler=getCultureDetail&filed=content&id='+i.id"
              v-if="i.type == 2">
                <div class="news_list_item">
                  <div class="ofl">
                    <img :src="i.imageUrl" alt>
                  </div>
                  <div class="sec_box font16">
                    <h5 class="text-center">{{i.title}}</h5>
                    <a href="#">{{$store.state.langData.culture.checkDetail}}</a>
                  </div>
                </div>
              </router-link> -->
              <div class="culture-link" v-if="i.type == 3">
                <div class="news_list_item">
                  <div class="ofl">
                    <img :src="i.imageUrl" alt>
                  </div>
                  <div class="sec_box font16">
                    <h5 class="text-center">{{i.title}}</h5>
                    <!-- <a :href="i.attachUrl">下载</a> -->
                    <!-- <p class="intro">{{i.matSpec}}</p> -->
                    <p class="indicationfunction">{{i.subhead | limitWord(70)}}</p>
                    <a @click.prevent="openUrl(i.attachUrl)">{{$store.state.langData.culture.download}}</a>
                    <!-- <p class="factory">{{i.matFactory}}</p> -->
                  </div>
                </div>
              </div>
              <div v-html="i.content" v-if="i.type == 4 || i.type == 2"></div>
            </div>
          </div>
          <div class="text-center" v-show="cultureList.length==0">{{$store.state.langData.noData}}</div>
          <div class="pagenation" v-show="totalPages>0" v-if="this.$route.query.type != 4 && this.$route.query.type != 2">
            <an-pagenation
              :startPage="startPage"
              :endPage="endPage"
              :currentPage="currentPage"
              @numberClick="handlePageClick"
              @lastClick="handleLastClick"
              @nextClick="handleNextClick"
              align="center"
            ></an-pagenation>
          </div>
        </div>
      </div>
    </an-child>
  </div>
</template>

<script>
import { getBanner } from "@/api";
import {getCultureClassify,getCultureList} from '@/api/hjy'
export default {
  name: "culture",
  data(){
      return {
          cleft:[],
          bannerImg:'',
          // content:'',
          cultureList:[],
          totalPages: 0, //总页数
          currentPage: 1, //当前页数
          startPage: 1, //开始页
          endPage: 1 //结束页
      }
  },
  methods:{
    openUrl(u){
      open(u,'new_blank')
    },
  	// 获取banner
      getBannerImg(){
        getBanner({'params':'6','ad_type':'6'}).then(res => {
          (this.bannerImg = res.list[0].imageUrl)
        });
      	this.bannerShow = true;
      },
    //获取分类
    getCultureClassify(){
      getCultureClassify()
      .then(res=>this.cleft.push(...res.data))
      .catch(e=>console.log(e))
    },
    // 获取富文本
    // getCulture(){
    //     getCultureDetail({'type':this.$route.query.type}).then(res => {
    //       (this.content = res.data.data[0].content)
    //     });
    // },
    getCultureList() {
      getCultureList({
        type: this.$route.query.type,
        page: this.currentPage,
        size: 10
      })
        .then(res => {
          this.cultureList = res.data.data;
          this.totalPages = res.data.totalPages;
          this.startPage = this.currentPage <= 2 ? 1 : this.currentPage - 2;
          if (this.startPage + 4 > this.totalPages) {
            this.endPage = this.totalPages;
            this.startPage = this.endPage - 4 < 1 ? 1 : this.endPage - 4;
          } else {
            this.endPage = this.startPage + 4;
          }
        })
        .catch(e => console.log(e));
    },
    handlePageClick(num) {
      this.currentPage = num;
      this.getCultureList();
    },
    handleLastClick() {
      this.currentPage === 1 ? null : this.currentPage--;
      this.getCultureList();
    },
    handleNextClick() {
      this.currentPage === this.totalPages ? null : this.currentPage++;
      this.getCultureList();
    }
  },
  mounted(){
    this.getCultureClassify();
    this.getBannerImg();
  },
  computed:{
    title(){
      let type=this.$route.query.type;
      let t='';
      this.cleft.map(n=>{
        if (n.type==type){
          t=n.name;
          return;
        }
      });
      // this.getCulture();
      this.currentPage = 1;
      this.getCultureList();
      return t;
    },
    type(){
      return this.cleft.length>0?this.cleft[0].type:''
    }
  }
};
</script>
<style lang="stylus">
  .bannerImg
    width 1200px
    height auto 
    margin 15px auto
    display block
  .about
    padding-bottom 88px
  .culture_list {
    overflow: hidden;

    .culture-link {
      display: block;
      float: left;
      width: 40%;
      margin: 1% 9% 1% 1%;
      height: 400px;
      transition: margin-top 2s;
      transition: box-shadow linear 0.3s;
      -o-transition: box-shadow linear 0.3s;
      -ms-transition: box-shadow linear 0.3s;
      -moz-transition: box-shadow linear 0.3s;
      -webkit-transition: box-shadow linear 0.3s;
      -moz-box-shadow: 0 0 11px rgba(43, 93, 151, 0.1);
      -webkit-box-shadow: 0 0 11px rgba(43, 93, 151, 0.1);

      img {
        width: 200px;
        margin: 0 auto;
        display:block;
        transition: all 0.6s;
      }
      .video_style{
        width 247px;
        height:248px;
      }

      img:hover {
        transform: scale(1.1);
      }

      h5 {
        margin-top: 30px;
        font-size: 18px;
        font-weight: normal;
        color: #333;
      }

      .intro {
        margin-left: 5%;
        line-height: 47px;
      }

      .indicationfunction {
        color: #999;
        font-size: 14px;
        line-height: 20px;
        padding: 0 5%;
      }

      .news_list_item {
        padding: 0 0 22px;
        border:0 !important;
      }
      a{
        width 100px
        height 28px
        color #fff
        letter-spacing 1px
        background #3385ff
        border-bottom 1px solid #2d78f4
        outline medium
        margin 20px auto
        display block
        text-align center
        font-size 16px
        line-height 28px
      }


      .e_time {
        color: #ED822A;
      }
    }

    .culture-link:hover {
      box-shadow: 0 0 12px #999;
      -webkit-box-shadow: 0 0 12px #999;
      -moz-box-shadow: 0 0 12px #999;
      -o-box-shadow: 0 0 12px #999;
    }
  }
</style>

